import { render, staticRenderFns } from "./ConfirmationRemoveFavourite.vue?vue&type=template&id=3df2434c&scoped=true"
import script from "./ConfirmationRemoveFavourite.vue?vue&type=script&lang=js"
export * from "./ConfirmationRemoveFavourite.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationRemoveFavourite.vue?vue&type=style&index=0&id=3df2434c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df2434c",
  null
  
)

export default component.exports